module.exports = __webpack_public_path__ + "img/album03_06.0b08ceb0.jpg";